import Image from "next/image"
import { trackBuyNowClick, trackPlayDemoClick } from "services/analytics"

import { Links } from "config/links"

import { Box } from "components/shared/box"
import { ClippedBox } from "components/shared/clipped-box/clipped-box"
import { OpenSea } from "components/shared/icons/opensea"
import { Button } from "components/shared/landing/button"
import { ClippedCard } from "components/shared/landing/clipped-card"
import { Section } from "components/shared/landing/section"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

import botsBattleImg from "/public/images/pages/index/bots-section/bots_battle.webp"

export function BotsSection() {
  return (
    <Section>
      <ClippedCard row full className="flex-col items-center md:justify-between md:flex-row-reverse">
        <Box center className="flex-1">
          <Box className="flex-1 max-w-[550px] mx-auto w-full">
            <ClippedBox corners={{ rt: true, lb: true }} className="rounded-lg overflow-hidden">
              <Image src={botsBattleImg} alt="robot image" />
            </ClippedBox>
          </Box>
        </Box>
        <Box className="flex-1 justify-center md:ml-4 mt-4 md:mt-0 md:pr-8">
          <Text as="h2" className="text-center md:text-left">
            Arena Bot Fights
          </Text>
          <p className="text-base text-white text-center opacity-80 mt-4 md:mt-6 md:text-left">
            Fight to the last drop of machine oil! Form the ultimate Bot squad to dominate PvP arenas and galactic
            tournaments!
          </p>
          <Box className="gap-7 md:gap-10 mt-6 md:flex-row items-center">
            <Link
              href={Links.OPENSEA_GENESIS}
              target="_blank"
              className="flex-1"
              withRedirect
              onClick={() => trackBuyNowClick("cryptobots_gameplay")}
            >
              <Button className="uppercase w-[200px] md:w-full" size="lg">
                <OpenSea w={20} h={20} className="mr-1" />
                Buy now
              </Button>
            </Link>
            <Link
              href={Links.GAME}
              target="_blank"
              className="flex-1"
              withRedirect
              onClick={() => trackPlayDemoClick("cryptobots_gameplay")}
            >
              <Button type="secondary" className="uppercase w-[200px] md:w-full" size="lg">
                Play testnet
              </Button>
            </Link>
          </Box>
        </Box>
      </ClippedCard>
    </Section>
  )
}
